export default "__VITE_ASSET__WMWO4eKK__"